module.exports = __webpack_public_path__ + "img/1_2.cdd5d7fd.gif";